import { render, staticRenderFns } from "./routePage.vue?vue&type=template&id=8bbf1b30&scoped=true&"
import script from "./routePage.vue?vue&type=script&lang=js&"
export * from "./routePage.vue?vue&type=script&lang=js&"
import style0 from "./routePage.vue?vue&type=style&index=0&id=8bbf1b30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbf1b30",
  null
  
)

export default component.exports